import styled from 'styled-components';

const StyledMedicineDetailsModalContent = styled.div`
   display: flex;
   flex-direction: column;
   max-height: 66vh;
   overflow: hidden;

   > * ~ * {
      margin-top: 8px;
   }
`;

StyledMedicineDetailsModalContent.displayName = 'StyledMedicineDetailsModalContent';

export { StyledMedicineDetailsModalContent };
